// Acessibilidade dos carrosséis de produtos (resource list).
// O tema marca como aria-hidden="true" todos os slides menos o "atual", mas o carrossel
// mostra vários cards ao mesmo tempo — deixando cards VISÍVEIS com aria-hidden + botões/links
// focáveis dentro (falha do Lighthouse: "[aria-hidden] contém descendentes focáveis").
//
// Correção (sem efeito visual — aria-hidden aqui só afeta leitor de tela + uma dica de
// content-visibility): slides fora da tela recebem `inert` (não focáveis e ocultos para AT);
// slides visíveis recebem aria-hidden="false". Escopo: só carrosséis com .resource-list__slide
// (não mexe na galeria do PDP nem no banner).
(function () {
  if (window.__a11yCarousel) return;
  window.__a11yCarousel = true;

  function apply(slide, visible) {
    if (visible) {
      if (slide.hasAttribute('inert')) slide.removeAttribute('inert');
      if (slide.getAttribute('aria-hidden') === 'true') slide.setAttribute('aria-hidden', 'false');
    } else if (!slide.hasAttribute('inert')) {
      slide.setAttribute('inert', '');
    }
  }

  function manage(comp) {
    if (comp.dataset.a11yManaged) return;
    var slides = comp.querySelectorAll('slideshow-slide.resource-list__slide');
    if (!slides.length) return;
    comp.dataset.a11yManaged = '1';

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) { apply(e.target, e.isIntersecting); });
      },
      { threshold: 0 }
    );
    slides.forEach(function (s) { io.observe(s); });

    // Se o tema remarcar um slide visível (sem inert) como aria-hidden, corrige de volta.
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var s = m.target;
        if (!s.hasAttribute('inert') && s.getAttribute('aria-hidden') === 'true') {
          s.setAttribute('aria-hidden', 'false');
        }
      });
    });
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }); });
  }

  function scan() {
    var comps = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < comps.length; i++) {
      if (comps[i].querySelector('slideshow-slide.resource-list__slide')) manage(comps[i]);
    }
  }

  function start() {
    scan();
    // Conteúdo que chega depois (ex.: recomendações via AJAX no carrinho).
    var tries = 0;
    var t = setInterval(function () { scan(); if (++tries >= 6) clearInterval(t); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
